import { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { Close } from '@mui/icons-material';

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  TablePagination,
  Typography
} from '@mui/material';

import {
  dialogHeaderStyles
} from '../../../../../Common/components/Styles/InputStyles';

import {
  paginationSx
} from '../../../../../Common/components/Listing/styles';

import VSHxTable from './VSHxTable';

import {
  vitalSignColumns,
  vitalSignRows
} from './VSHxData';

import {
  closeButtonSx,
  dialogActionsSx,
  dialogContentSx,
  tablePaperSx
} from './VSHxStyles';

const VSHx = ({ open, onCancel }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handlePageChange = (_, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(Number(event.target.value));
    setPage(0);
  };

  const visibleRows = useMemo(() => {
    const start = page * rowsPerPage;

    return vitalSignRows.slice(
      start,
      start + rowsPerPage
    );
  }, [page, rowsPerPage]);

  const handleCopy = row => {
    const vitalSignData = [
      `Date: ${row.date}`,
      `BP: ${row.bp}`,
      `Temp: ${row.temp}`,
      `HR: ${row.hr}`,
      `RR: ${row.rr}`,
      `WT: ${row.wt}`,
      `HT: ${row.ht}`,
      `BMI: ${row.bmi}`
    ].join('\n');

    navigator.clipboard
      ?.writeText(vitalSignData)
      .catch(error => {
        console.error(
          'Unable to copy vital signs:',
          error
        );
      });
  };

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      fullWidth
      maxWidth="md">

      <DialogTitle sx={dialogHeaderStyles.dialogheader}>
        <Box>
          <Typography sx={dialogHeaderStyles.title}>
            Vital Signs
          </Typography>

          <Typography sx={dialogHeaderStyles.subtitle}>
            Review historical vital signs.
          </Typography>
        </Box>

        <IconButton
          aria-label="Close vital signs dialog"
          onClick={onCancel}
          size="small"
          sx={dialogHeaderStyles.dialogheaderclose}>
          <Close sx={{ fontSize: 22 }} />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={dialogContentSx}>
        <Paper
          variant="outlined"
          sx={tablePaperSx}>

          <VSHxTable
            rows={visibleRows}
            columns={vitalSignColumns}
            onCopy={handleCopy}
          />

          <TablePagination
            component="div"
            count={vitalSignRows.length}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[10, 15, 25]}
            labelRowsPerPage="Rows per page:"
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            sx={paginationSx}
          />
        </Paper>
      </DialogContent>

      <DialogActions sx={dialogActionsSx}>
        <Button
          variant="contained"
          onClick={onCancel}
          size="small"
          sx={closeButtonSx}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

VSHx.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired
};

export default VSHx;